import Tween from "tween.ts";
import Animation from "../Animation";
import Line from "../../entities/Line";
import { Coord } from "../../types/Interface";


export default class DrawLineAnim extends Animation {
  constructor(Line: Line, readonly sCoord: Coord, readonly tCoord: Coord, onComp: () => void) {
    super();
    new Tween.Tween({ ...sCoord })
      .to({ x: tCoord.x, y: tCoord.y }, 1000)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((coord: Coord, u) => {
        Line.draw(sCoord, coord);
      })
      .onComplete(() => onComp())
      .start();
  }
}